exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-remark{display:block;padding-top:10px}.label{display:inline;padding:.2em .6em .3em;font-size:70%;font-weight:700;line-height:1;color:#2e2e2e;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em;background-color:#eceff4}.info-icon{cursor:pointer}textarea{padding:15px;margin-top:5px;width:80%;border:2px solid #f2f2f2}.success-message{padding:15px;border:2px solid #02b302;color:#02b302;margin-top:15px}.error-message{padding:15px;border:2px solid #cc0909;color:#cc0909;margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9b1a4c9a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/QuestionRemark.vue
// module id = 194
// module chunks = 0